{
  "version": 1,
  "asset_id": "d199bf97-d827-4cbe-a966-6cd6a734a981",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/d199bf97-d827-4cbe-a966-6cd6a734a981/ind-automotive-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/d199bf97-d827-4cbe-a966-6cd6a734a981/ind-automotive-640.webp",
  "original_filename": "ind-automotive-640.webp",
  "size": 14658,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:25:55Z"
}
